export const themeColors = {
  paper: "#ffffff",
  darkPaper: "#000000",

  // Primary
  primaryLight: "#fff8e1",
  primaryMain: "#fe9d0b",
  primaryDark: "#fd6c0c",
  primary200: "#ffde82",
  primary800: "#fe8c0b",

  // primaryLight: "#d35590",
  // primaryMain: "#9e1f63",
  // primaryDark: "#6b0039",
  // primary200: "#e890bb",
  // primary100: "#f0bbd6", //#f1dbe3
  // primary50: "#ffecf4",

  // Secondary
  secondaryLight: "#fce8e7",
  secondaryMain: "#ee3518",
  secondaryDark: "#c71a07",
  secondary200: "#ffa690",
  secondary800: "#e02c13",

  // secondaryLight: "#ff9d45",
  // secondaryMain: "#f15a29",
  // secondaryDark: "#b72500",
  // secondary200: "#fdae95",
  // secondary100: "#fdcebf",
  // secondary50: "#faeae8",

  // Success
  successLight: "#81c784",
  successMain: "#2e7d32",
  successDark: "#1b5e20",
  success200: "#a5d6a7",
  success800: "#859303",

  // Error
  // errorMain: "#d32f2f",
  // errorLight: "#ef5350",
  // errorDark: "#c62828",

  errorLight: "#ef9a9a",
  errorMain: "#f44336",
  errorDark: "#c62828",

  // orange
  orangeLight: "#fbe9e7",
  orangeMain: "#ffab91",
  orangeDark: "#d84315",

  // warning
  warningLight: "#fff8e1",
  warningMain: "#ffe57f",
  warningDark: "#ffc107",

  // Grey
  grey50: "#fafafa",
  grey100: "#f5f5f5",
  grey200: "#eeeeee",
  grey300: "#e0e0e0",
  grey400: "#bdbdbd",
  grey500: "#9e9e9e",
  grey600: "#757575",
  grey700: "#616161",
  grey800: "#333333",
  grey900: "#212121",
};
